import React from 'react';
import { Table } from 'antd';

const Spreadsheet = ({ rows }) => {
    if (!rows || rows.length === 0) {
        return <p>No data available</p>;
    }

    // The first row contains the column headers
    const columns = rows[0].map((header, index) => ({
        title: header,
        dataIndex: String(index),
        key: String(index),
    }));

    // The rest of the rows are the data
    const dataSource = rows.slice(1).map((row, rowIndex) => {
        const rowData = {};
        row.forEach((cell, cellIndex) => {
            rowData[String(cellIndex)] = cell;
        });
        return {
            key: String(rowIndex),
            ...rowData,
        };
    });

    return (
        <Table
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            bordered
            size={'middle'}
        />
    );
};

export default Spreadsheet;
